module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.type === 'null') ? _c('span', {
    staticClass: "object-tree-node-primitive object-tree-node-null"
  }, [_vm._v("null")]) : (_vm.type === 'undefined') ? _c('span', {
    staticClass: "object-tree-node-primitive object-tree-node-undefined"
  }, [_vm._v("undefined")]) : (_vm.type === 'number') ? _c('span', {
    staticClass: "object-tree-node-primitive object-tree-node-number"
  }, [_vm._v(_vm._s(_vm.value))]) : (_vm.type === 'string') ? _c('span', {
    staticClass: "object-tree-node-primitive object-tree-node-string"
  }, [_vm._v("\"" + _vm._s(_vm.value) + "\"")]) : (_vm.type === 'boolean') ? _c('span', {
    staticClass: "object-tree-node-primitive object-tree-node-boolean"
  }, [_vm._v(_vm._s(_vm.value))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42538298!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-object-view/ObjectTreeNodePrimitive.vue
// module id = 1540
// module chunks = 2